import { Injectable } from '@angular/core';

import {ParagraphLogoSliderData,ParagraphSmallColumnModuleData, MultipleColumnItemDataInner, ParagraphMultipleColumnData, ParagraphMultipleColumnItemData } from '@generated/content';
import {

  MediaImageData,

} from '@generated/content';
import { TMediaNodeType } from '@interfaces/media';

import { CmsComponentNodeData } from '@interfaces/cms-component-node-data';
import { LogoSlider } from '@interfaces/config/cms-components/sliders/logo-slider-config';


import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';

import {  CmsComponentTypeEnum, MediaTypesEnum } from '@models/enums';
import { CmsComponentConfig, TextMediaBox } from '@interfaces/config';

import { MediaResolver } from '@services/resolvers/auxiliary/media-resolver';


@Injectable({ providedIn: 'root' })
export class LogoSliderComponentResolver extends BaseComponentResolver {
  static override instance: LogoSliderComponentResolver;
  private readonly componentType = LogoSlider.TypeEnum;

  static getInstance(): LogoSliderComponentResolver {
 
    return (LogoSliderComponentResolver.instance ||= new LogoSliderComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphLogoSliderData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<LogoSlider.ComponentConfig> | null {
    if (!node) {
      return null;
    }

 

    this.nodePageData = nodePageData;
    
    let columns = this.getColumns(node);
    let sliderImages = [];
    for(let i  = 0 ; i < columns.length; i++){
       let column = columns[i];
  
       sliderImages.push({image:column.dataUrls['medium_1280w'], thumbImage:column.dataUrls['thumbnail']});
    }
  
     
   
   return {
      componentType: this.componentType,
      config: {
        nodeId: BaseComponentResolver.getNodeId(node),
        anchor_id : node.attributes.field_anchor_id,
        columns,
        sliderImages
        
      },
    };


    
  }




  private getColumns(node: ParagraphLogoSliderData):  TextMediaBox.MediaImageConfig[] {



    if (!node.relationships.field_logo?.data?.length) {
      return [];
    }
    

     return node.relationships.field_logo.data.map(item => this.buildColumnConfig(item));
  }


  private buildColumnConfig(node: any): TextMediaBox.MediaImageConfig | null {
    const { id, type } = node;
  
    if (!(id && node)) {
      return null;
    }

 
    const columnNode = this.getNode<MediaImageData>(id, type);


    if (!columnNode) {
      return null;
    }

     const media = this.getMediaConfig(columnNode);

    return  media;


  }



      private getMediaConfig(
        node: MediaImageData
      ):
         TextMediaBox.MediaImageConfig
        {
          
      
 
        const { type, id } = node;
    
        
      
        switch (type) {
          case MediaImageData.TypeEnum.MediaImage:
            const { dataUrls, metas } = this.getMediaDataUrls(id, type as TMediaNodeType, null, true);
            return {
              type: MediaTypesEnum.IMAGE,
              dataUrls,
              metas,
              fill: false,
              sizes: MediaResolver.buildImageConfigSizes(CmsComponentTypeEnum.CARDS),
            };
    
         
    
          default:
            return null;
        }
      }
    
 

    


}
